import ViewAppsHome from "../views/ViewAppsHome.vue"
import ViewAppsConfig from "../views/ViewAppsConfig.vue"
import ViewAppsDetail from "../views/ViewAppsDetail.vue"

export default [
	{
		path: "/apps",
		component: ViewAppsHome,
		name: "ViewAppsHome",
		meta: {}
	},
	{
		path: "/apps/detail/:appId",
		component: ViewAppsDetail,
		name: "ViewAppsDetail",
		props: true,
		meta: {}
	},
	{
		path: "/apps/detail/config/:appId",
		component: ViewAppsConfig,
		name: "ViewAppsConfig",
		props: true,
		meta: {}
	}
]
